import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { UserDetail } from '@/types/domain'

export const useAuthStore = defineStore('auth', () => {
  const signedIn = ref(false)
  const user = ref<Partial<UserDetail>>({})

  const isSignedIn = computed(() => signedIn.value && !!user.value.id)
  const isCorporate = computed(() => user.value.corporate ?? false)
  const isFederated = computed(() => user.value.federated ?? false)
  const isAdmin = computed(() => user.value.admin ?? false)
  const isManager = computed(() => user.value.manager ?? false)
  const hasAnyRoleAdmin = computed(() => isManager.value || isAdmin.value)

  async function fetchSignedIn() {
    const { auth } = await import('@/services')

    signedIn.value = await auth.getSignedIn()
  }

  async function fetchUserDetail() {
    const { api } = await import('@/services')
    try {
      const detail = await api.getLoggedUserDetail()
      user.value = detail
      const storedRegion = localStorage.getItem('region')
      if (!storedRegion && detail.country?.region?.name) {
        localStorage.setItem('region', detail.country.region.name)
      }
    } catch {
      // user detail is optional during init; navigation guard will redirect on 403
    }
  }

  function $reset() {
    signedIn.value = false
    user.value = {}
  }

  return {
    signedIn,
    user,
    isSignedIn,
    isCorporate,
    isFederated,
    isAdmin,
    isManager,
    hasAnyRoleAdmin,
    fetchSignedIn,
    fetchUserDetail,
    $reset,
  }
})
